module.exports = __webpack_public_path__ + "img/featureback2.2a889e55.png";